import { _ } from "../../../polyglot/polyglot.js";
import { makeMonitorRepository } from "../../../repositories/repositoryBuilders.js";
import AbstractImporter from "../AbstractImporter.js";
import AuthenticationStep from "../AuthenticationStep.js";
import IsaasJob from "../../../../models/IsaasJob.js";
import session from "../../../session.js";

/**
 * `ISaasImporter` Import wizard for iSaaS. Subclasses must provide a
 * connector type to identify from where the data will be fetched.
 *
 * @abstract
 */
export default class IsaasImporter extends AbstractImporter {
	constructor() {
		super(...arguments);

		this._isaasJobRepository = makeMonitorRepository({
			route: "/Shared/Import/Isaas/CreateJob",
			model: IsaasJob,
			antiForgeryToken: session.getAntiForgeryToken(),
		});

		this._isaasImportRepository = makeMonitorRepository({
			route: "/Shared/Import/Isaas/Import",
			antiForgeryToken: session.getAntiForgeryToken(),
		});
	}

	_wizardSteps() {
		return [this._createJobStep()];
	}

	_createJobStep() {
		return new AuthenticationStep({
			submitCallback: this._launchAuthenticationFlow.bind(this),
		});
	}

	_getConnectorType() {
		return this._subclassResponsibility();
	}

	async _launchAuthenticationFlow({ onDone, step }) {
		const job = await this._isaasJobRepository.save({
			filter: {
				connectorType: this._getConnectorType(),
				agencyId: this.getAgencyId(),
				companyId: this.getCompanyId(),
			},
			notify: false,
		});

		if (job.isAuthenticationRequired()) {
			const url = job.getAuthenticateUrl();

			const windowProxy = window.open(
				url,
				"Authentication",
				"width=1000,height=1000",
			);

			if (windowProxy === null) {
				step.addSubmitError(
					_(
						"Your browser blocked the popup for authentication - we won't be able to proceed with the import. Open the blocked popup and authenticate to proceed",
					),
				);

				onDone();
			}
		}

		const jobId = job.getId();

		this._context.importData = await this._isaasImportRepository.get({
			filter: {
				jobId,
			},
			notify: false,
		});

		onDone();
	}

	_wantExtendedActionsInConfigureImportDataStep() {
		return true;
	}
}
